import { Component, OnInit, Input } from '@angular/core';
import { CaseService } from '../../services/case.service';
import { UtilitiesService } from '../../services/utilities.service';
import { ApplicationMinutesDto } from './dto/application-minutes.dto';

@Component({
    selector: 'app-case-minutes',
    templateUrl: './case-minutes.component.html'
})
export class CaseMinutesComponent implements OnInit {

    @Input() caseId: string;
    myMinutes: any[];// ApplicationMinutesDto[];
    cols: any[];

    constructor(private caseService: CaseService, private utilService: UtilitiesService) { }

    ngOnInit() {
        // GET Minutes data for this application
        this.cols = [
            { field: 'hearingDate', header: 'Hearing Date' },
            { field: 'minutesNote', header: 'Notes' },
        ];
        this.myMinutes = [];
        if (this.caseId) {
            this.caseService.getCaseMinutes(this.caseId).subscribe(data => {
                this.utilService.doAudit(data, 'Minutes data:');
                this.myMinutes = data;
            });
        }
    }
}
